export interface Customer {
  id: number;
  tenant_id: number;

  // Personal data
  customer_number: string | null;
  salutation: string | null;
  first_name: string | null;
  last_name: string | null;
  company_name: string | null;

  // Contact
  email: string | null;
  phone: string | null;
  mobile: string | null;

  // Address
  street: string | null;
  postal_code: string | null;
  city: string | null;
  country: string;

  // Driver's license
  license_number: string | null;
  license_issued_at: string | null;
  license_expires_at: string | null;
  license_class: string | null;

  // Date of birth
  date_of_birth: string | null;

  // Notes
  notes: string | null;

  // Status
  is_active: boolean;
  is_blacklisted: boolean;
  blacklist_reason: string | null;

  // Timestamps
  created_at: string;
  updated_at: string;
}

export interface CustomerCreate {
  customer_number?: string;
  salutation?: string;
  first_name?: string;
  last_name?: string;
  company_name?: string;
  email?: string;
  phone?: string;
  mobile?: string;
  street?: string;
  postal_code?: string;
  city?: string;
  country?: string;
  license_number?: string;
  license_issued_at?: string;
  license_expires_at?: string;
  license_class?: string;
  date_of_birth?: string;
  notes?: string;
  is_active?: boolean;
  is_blacklisted?: boolean;
  blacklist_reason?: string;
}

export type CustomerUpdate = Partial<CustomerCreate>;

export interface CustomerListResponse {
  customers: Customer[];
  total: number;
  page: number;
  page_size: number;
  total_pages: number;
}

// Helper function to get customer display name
export function getCustomerDisplayName(customer: Customer): string {
  if (customer.company_name) {
    return customer.company_name;
  }
  if (customer.first_name && customer.last_name) {
    return `${customer.first_name} ${customer.last_name}`;
  }
  if (customer.first_name) {
    return customer.first_name;
  }
  if (customer.last_name) {
    return customer.last_name;
  }
  return customer.customer_number || `Kunde #${customer.id}`;
}

// Helper function to format address
export function formatAddress(customer: Customer): string {
  const parts: string[] = [];
  if (customer.street) parts.push(customer.street);
  if (customer.postal_code && customer.city) {
    parts.push(`${customer.postal_code} ${customer.city}`);
  } else if (customer.city) {
    parts.push(customer.city);
  }
  return parts.join(', ') || '-';
}
